import React, { useEffect } from "react";

import { Route, Routes, useLocation } from "react-router-dom";

import LandingPage from "./features/landingPage";
import { Toaster } from "react-hot-toast";

import CourtHistory from "./features/pages/CourtHistory";
import PresidentJudges from "./features/pages/PresidentJudges";
import ChiefRegistrar from "./features/pages/ChiefRegistrar";
import Admin from "./features/pages/Admin";
import News from "./features/pages/News";
import EvenetDetails from "./features/pages/EvenetDetails";
import PhotoGallery from "./features/pages/PhotoGallery";
import PhotoDetails from "./features/pages/PhotoDetails";
import CourtDocuments from "./features/pages/CourtDocuments";
import Publications from "./features/pages/Publications";
import PublicationDetails from "./features/pages/PublicationDetails";
import Faqs from "./features/pages/Faqs";
import ContactUs from "./features/pages/ContactUs";
import CauseList from "./features/pages/CauseList";
import Login from "./features/modules/auth/Login";
import Private from "./routes/Private";
import MainRoutes from "./routes/main";

function App() {
  const location = useLocation();

  const { pathname } = location;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <>
      <Toaster position="top-right" />

      <Routes>
        <Route
          path="/*"
          element={
            <Private>
              <MainRoutes />
            </Private>
          }
        />

        <Route path="/login" element={<Login />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/court-history" element={<CourtHistory />} />
        <Route path="/president-judges" element={<PresidentJudges />} />
        <Route path="/chief-registrar" element={<ChiefRegistrar />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/news" element={<News />} />
        <Route path="/event-details" element={<EvenetDetails />} />
        <Route path="/photo-gallery" element={<PhotoGallery />} />
        <Route path="/photo-details" element={<PhotoDetails />} />
        <Route path="/court-documents" element={<CourtDocuments />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/publication-details" element={<PublicationDetails />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/cause-list" element={<CauseList />} />
      </Routes>
    </>
  );
}

export default App;
